'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M7 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9.243a2 2 0 0 0-.586-1.415l-4.242-4.242A2 2 0 0 0 12.757 3zM3 5a4 4 0 0 1 4-4h5.757a4 4 0 0 1 2.829 1.172l4.242 4.242A4 4 0 0 1 21 9.243V19a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 13a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 17a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M13 8V2h2v6h5v2h-5a2 2 0 0 1-2-2" clipRule="evenodd" /></svg>;
const IconTextFile = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconTextFile;